import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { Box, Button } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { H3 } from '../../../layouts/TextStyles'
import CustomInput from '../../../components/muiComponents/customInput'
import DatePicker from '../../../components/muiComponents/datePicker/DatePicker'
import { salesApi } from '../../../features/sales/sales'
import { formatDateToCalendarDate } from '../../../utils/functions'
import SalesReportTable from './components/SalesReportTable'
import {
    Content,
    Header,
    TotalInfoText,
    Title,
    TotalInfoBox,
    TotalSum,
    Wrapper,
    DateWrapper,
    ComponentsWrapper,
    SearchStyles,
    FilterBox
} from './style'

const SalesReportListPage = () => {
    const { formatMessage } = useIntl()
    const [startDate, setStartDate] = React.useState<Date>()
    const [endDate, setEndDate] = React.useState<Date>()
    const [filter, setFilter] = useState('')
    const [searchParams, setSearchParams] = useSearchParams('')
    const [page, setPage] = React.useState(+searchParams.get('page') || 1)
    const [type, setType] = useState(searchParams.get('type') || "PAID")
    const [rowsPerPage, setRowsPerPage] = React.useState(
        +searchParams.get('size') || 5,
    )

    const [
        fetchSalesProfit,
        { data: volume = 0, isFetching: isFetchingSalesProfit },
    ] = salesApi.useLazyFetchSalesProfitQuery()

    const [
        fetchSalesAnalyzes,
        { data: analysisResponse = null, isFetching: isFetchingSalesAnalyzes },
    ] = salesApi.useLazyFetchSalesAnalyzesQuery()

    const isFetching = isFetchingSalesProfit || isFetchingSalesAnalyzes

    const fetchAnalyzes = (resetPage = false) => {
        if(resetPage && page !== 1) setPage(1) // поиск баскан кезде сбрасываем page, чтобы через useEffect шакырылу ушин
        else {
            const startDateParam = startDate
                ? formatDateToCalendarDate(startDate, '-', ['yyyy', 'mm', 'd'])
                : undefined

            const endDateParam = endDate
                ? formatDateToCalendarDate(endDate, '-', ['yyyy', 'mm', 'd'])
                : undefined

            
            fetchSalesProfit({
                startDate: startDateParam,
                endDate: endDateParam,
                filter
            })

            fetchSalesAnalyzes({
                startDate: startDateParam,
                endDate: endDateParam,
                filter,
                page: page - 1,
                size: rowsPerPage,
                type
            })
        }
    }

    const handleChangeType = (e, newType) => {
        setType(newType)
    }

    useEffect(() => {
        fetchAnalyzes()
    }, [])

    useEffect(() => {
        // при изменении type
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
            type
        }
        setSearchParams(params)
        fetchAnalyzes(true);
    }, [type]);

    useEffect(() => {
        const params = {
            page: page.toString(),
            size: rowsPerPage.toString(),
            type
        }
        setSearchParams(params)
        fetchAnalyzes()
    }, [rowsPerPage, page])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3> {formatMessage({ id: 'salesReport' })} </H3>
                    </Title>
                    
                    <FilterBox>
                         <Tabs value={type} onChange={handleChangeType} aria-label="lab API tabs example">
                            <Tab label="Төленгендер" value="PAID" />
                            <Tab label="Барлығы" value="ALL" />
                        </Tabs>

                        <TotalSum>
                            <TotalInfoText>
                                {formatMessage({ id: 'totalCash' })}
                            </TotalInfoText>
                            <TotalInfoBox>{volume?.toLocaleString()} т</TotalInfoBox>
                        </TotalSum>
                    </FilterBox>
                     
                </Header>

                <ComponentsWrapper>
                    <Box sx={SearchStyles.filterBox}>
                        <Box sx={SearchStyles.searchBox}>
                            <CustomInput
                                sx={SearchStyles.search}
                                margin="none"
                                type="text"
                                placeholder={formatMessage({ id: 'search' })}
                                size="small"
                                onChange={(e) => setFilter(e.target.value)}
                            />

                            <Button
                                variant="contained"
                                onClick={() => fetchAnalyzes(true)}
                            >
                                {formatMessage({ id: 'search' })}
                            </Button>
                        </Box>
                    </Box>

                    <DateWrapper>
                        <DatePicker
                            label={formatMessage({ id: 'startDateTime' })}
                            value={startDate}
                            small={true}
                            handleChange={(event) => setStartDate(event)}
                        />

                        <DatePicker
                            label={formatMessage({ id: 'endDateTime' })}
                            value={endDate}
                            small={true}
                            handleChange={(event) => setEndDate(event)}
                        />

                        <Button
                            variant="contained"
                            onClick={() => fetchAnalyzes(true)}
                        >
                            {formatMessage({ id: 'withdraw' })}
                        </Button>
                    </DateWrapper>
                </ComponentsWrapper>

                {isFetching ? (
                    <LinearProgress />
                ) : (
                    analysisResponse && (
                        <SalesReportTable
                            isFetching={isFetching}
                            analyzes={analysisResponse.data}
                            pageNumber={analysisResponse.pageNumber}
                            totalCount={analysisResponse.totalCount}
                            totalPages={analysisResponse.totalPages}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    )
                )}
            </Content>
        </Wrapper>
    )
}
export default SalesReportListPage

